import Vue from "vue";

export default {
  resetCart(state, list) {
    state.cart = {
      list: [],
      promo: [],
      donations: [],
      additional: [],
      upsell: [],
      additionalBaskets: [],
      price: 0,
      orderItems: [],
    };
    state.finalOrder = {
      basketPrice: 0,
      membersPrice: 0,
      totalPrice: 0,
      disc: 0,
      totalDiscountedPrice: 0,
      emailToConfirm: "",
      perTransactionFee: 0,
      processOrder: 0,
    };
    for (let i = 0; i < list.length; i++) {
      for (let j = 0; j < state.list.length; j++) {
        if (list[i].id === state.list[j].id) {
          state.list[j].paid = true;
        }
      }
    }
  },

  fillAuxPayment(state, payInfo) {
    // console.log("-=-=-old payment info-=-=-", payInfo.total);
    // state.finalOrderAux.total = payInfo.total;
  },

  fixTotal(state) {
    let shopCar = [];
    state.cart.orderItems.forEach((item) => {
      if (item.itemId === 666) {
        state.finalOrderAux.total = state.finalOrderAux.total - item.price;
      } else shopCar.push(item);
    });

    state.cart.orderItems = [...shopCar];
  },

  updateTransaction(state, id) {
    console.log("tran id ", id);
    state.finalOrder.tranID = id;
  },
  updateListInPromotions(state, items) {
    console.log("itemzzz ", items);
    state.comboPromotions = items;
  },
  updateLocalDelivery(state, items) {
    state.localDeliveryPricing = items;
  },
  updateTotal(state, item) {
    state.total = item;
  },
  updateDiscounts(state, items) {
    state.discounts = items;
  },
  updatePaymentMethods(state, items) {
    state.paymentMethods = items;
  },
  updateSettings(state, item) {
    state.settings = item;
  },
  updateReciprocity(state, item) {
    state.cart.reciprocity = item;
  },
  updateShippingCustomOptions(state, items) {
    state.shippingCustomOptions = items;
  },
  updateOrderItems(state, items) {
    state.cart.orderItems = [];
    for (let i = 0; i < items.length; i++) {
      if (items[i].itemId !== 2) {
        state.cart.orderItems.push(items[i]);
      }
    }
    // console.log("state.cart.orderItems", state.cart.orderItems)
  },
  showToast(state, item) {
    Vue.$toast.open({
      message: item.message,
      type: item.type,
      position: item.position,
      duration: 5000,
      // all of other options may go here
    });
  },
  updateLoginInfo(state, items) {
    state.loginInfo = items;
  },
  updateOrderOptions(state, items) {
    for (let i = 0; i < items.length; i++) {
      items[i].value = 0;
      items[i].quantities = [];
      let j = 0;
      while (j <= items[i].maxQuantity) {
        items[i].quantities.push(j);
        j++;
      }
      state.orderOptions.push(items[i]);
    }
  },
  updateCharityCustom(state, items) {
    for (let i = 0; i < items.length; i++) {
      items[i].value = 0;
      items[i].disabledLabel = items[i].chaMessage;
      state.charitycustom.push(items[i]);
    }
    // if (!state.charity.length && items.length) {
    // 	console.log('zzzzzzzzzzzzzz')
    // 	for (let i = 0; i < items.length; i++) {
    // 		state.charity.push({
    // 			charity: "",
    // 			customLabel: items[i].chaMessage,
    // 			charityGuid: "",
    // 			charityId: items[i].chaId,
    // 			dateAdded: "",
    // 			deleted: items[i].chaActive,
    // 			disabledLabel: "Donation To Charity",
    // 			displayOrder: 0,
    // 			lastUpdated: "",
    // 			shulId: items[i].chaShul,
    // 			value: 0,
    // 			hide:false
    // 		})
    // 	}
    // }
    // else if(state.charity.length && items.length){
    // 	console.log("else")
    // 	for (let i = 0; i < items.length; i++) {
    // 		state.charity.unshift({
    // 			charity: "",
    // 			customLabel: items[i].chaMessage,
    // 			charityGuid: "",
    // 			charityId: items[i].chaId,
    // 			dateAdded: "",
    // 			deleted: items[i].chaActive,
    // 			disabledLabel: "Donation To Charity",
    // 			displayOrder: 0,
    // 			lastUpdated: "",
    // 			shulId: items[i].chaShul,
    // 			value: 0,
    // 			hide:true
    // 		})
    // 	}
    // }
  },
  updateCharity(state, items) {
    for (let i = 0; i < items.length; i++) {
      items[i].value = 0;
      items[i].disabledLabel = "Donation To Charity - " + items[i].charity;
      items[i].customLabel = null;
      items[i].hide = false;
      state.charity.push(items[i]);
    }
  },
  updatePromotions(state, items) {
    let paid = [];
    let notpaid = [];
    for (let i = 0; i < items.length; i++) {
      items[i].disabled = false;
      if (items[i].orderItemID) {
        items[i].value = true;
      } else {
        items[i].value = false;
      }
      if (items[i].transactionID) {
        items[i].paid = true;
      } else {
        items[i].paid = false;
      }
      items[i].allCategories = [];
      if (items[i].categories.length) {
        let c = items[i].categories.split(",");
        if (c.length) {
          for (let j = 0; j < c.length; j++) {
            if (c[j].length) {
              items[i].allCategories.push(c[j]);
            }
          }
        }
      }
      if (items[i].joinCategories.length) {
        let k = items[i].joinCategories.split(",");
        if (k.length) {
          for (let z = 0; z < k.length; z++) {
            if (k[z].length && k[z] !== "0") {
              items[i].allCategories.push(k[z]);
            }
          }
        }
      }
      if (!items[i].paid) {
        notpaid.push(items[i]);
      } else {
        state.promotions.push(items[i]);
      }
      for (let z = 0; z < notpaid.length; z++) {
        let f = state.promotions.filter((a) => a.id === notpaid[z].id);
        if (!f.length) {
          state.promotions.push(notpaid[z]);
        }
      }
    }
  },
  updateCategories(state, items) {
    state.categories = items;
  },
  updateOrganization(state, items) {
    state.organizationInfo = items;
  },
  updateProfile(state, items) {
    state.userProfile = items;
  },
  updateProfileOptions(state, items) {
    state.profileOptions = items;
    state.profileOptionsCopy = items;
  },
  updateCustomProfileOptions(state, items) {
    let obj = {};
    let arr = [];
    for (let i = 0; i < items.length; i++) {
      if (obj[items[i].optId] === undefined)
        obj[items[i].optId] = {
          data: [],
          id: "",
          selValue: "",
          type: "",
          label: "",
          required: false,
        };
      obj[items[i].optId].data.push(items[i]);
      obj[items[i].optId].id = items[i].optId;
      if (obj[items[i].optId].data.length) {
        obj[items[i].optId].selValue = obj[items[i].optId].data[0].optValue;
        obj[items[i].optId].type = obj[
          items[i].optId
        ].data[0].optType.toLowerCase();
        obj[items[i].optId].label = obj[items[i].optId].data[0].optLabel;
        obj[items[i].optId].required = obj[items[i].optId].data[0].optRequired;
      }
    }
    for (let i in obj) {
      arr.push(obj[i]);
    }
    state.profileCustomOptions = arr;
    localStorage.setItem("profileCustomOptions", JSON.stringify(arr));
  },
  addToList(state, item) {
    state.list.push(item);
  },
  updateList(state, items) {
    state.list = [];
    state.list = items;
    let prices = [];
    for (let i = 0; i < state.list.length; i++) {
      // console.log("state.list[i].price",state.list[i].price, state.list[i].customPrice)
      if (prices.indexOf(state.list[i].price) === -1) {
        prices.push(state.list[i].price);
      }
      if (state.list[i].price <= 0) {
        state.list[i].price = state.organizationInfo[0].sPerperson;
      }
      state.list[i].basketType = "";
      state.list[i].mCategories = [];
      if (state.list[i].memberCategories.length) {
        let cat = state.list[i].memberCategories.split(",");
        for (let j = 0; j < cat.length; j++) {
          state.list[i].mCategories.push(Number(cat[j]));
        }
      }
      if (state.organizationInfo[0].id === 647) {
        if (state.list[i].customPrice === 0 && state.list[i].price === 0) {
          state.list[i].basketType = "Regular Baskets";
        } else {
          let obj = [];
          if (state.list[i].customPrice !== 0) {
            obj = state.shippingCustomOptions.filter(
              (a) => a.price === state.list[i].customPrice
            );
          } else {
            obj = state.shippingCustomOptions.filter(
              (a) => a.price === state.list[i].price
            );
          }
          if (obj.length) {
            state.list[i].basketType = obj[0].description;
            state.list[i].price = obj[0].price;
          } else {
            state.list[i].basketType = "Regular Baskets";
            state.list[i].price = state.organizationInfo[0].sPerperson;
          }
        }
      }
    }
    for (var i = 0; i < state.list.length; i++) {
      if (state.list[i].selected && !state.list[i].paid) {
        state.cart.list.push(state.list[i]);
      }
    }
    if (prices.length > 1) {
      state.showPrices = true;
    }
    // last year order screen
    let lastYear = [];
    let obj1 = state.list.filter(
      (data) =>
        data.iSentLastYear === 1 &&
        data.reciprocal !== "Yes" &&
        data.sentToMeLastYear === 0
    );
    let obj2 = state.list.filter(
      (data) => data.sentToMeLastYear === 1 && data.reciprocal !== "Yes"
    );
    let obj3 = state.list.filter((data) => data.reciprocal === "Yes");
    lastYear = obj1.concat(obj2, obj3);
    state.lastYear = lastYear;
  },
  addDonation(state, item) {
    let len = state.cart.donations.filter((d) => d.charityId === item.charityId)
      .length;
    if (!len) {
      state.cart.donations.push(item);
    } else {
      for (let i = 0; i < state.cart.donations.length; i++) {
        if (state.cart.donations[i].charityId === item.charityId) {
          state.cart.donations[i].value = item.value;
          state.cart.donations[i].Price = item.Price;
        }
      }
    }
  },
  addBaskets(state, item) {
    if (!state.cart.additional.length) {
      state.cart.additional.push(item);
    } else {
      state.cart.additional[0].Qt = item.Qt;
    }
  },
  addAdditionalBasket(state, item) {
    //console.log("pushing ITEM ", item)
    state.cart.additionalBaskets.push(item);
  },
  updateBaskets(state, items) {
    state.cart.additionalBaskets = items;
  },
  addUpsell(state, items) {
    //console.log("items ", items)
    for (let i = 0; i < items.length; i++) {
      let f_arr = state.cart.upsell.filter((a) => a.ID === items[i].id);
      if (f_arr.length) {
        for (let j = 0; j < state.cart.upsell.length; j++) {
          if (state.cart.upsell[j].ID === items[i].id) {
            state.cart.upsell[j].Value += items[i].value;
            state.cart.upsell[j].Qt += items[i].value;
          }
        }
      } else {
        let obj = {
          ID: items[i].id,
          Label: items[i].description,
          Price: items[i].price,
          Value: Number(items[i].value),
          Qt: Number(items[i].value),
        };
        state.cart.upsell.push(obj);
      }
    }
  },
  addToCart(state, item, prop) {
    state.cart.promo.push(item);
  },
  addListToCart(state, items) {
    console.log("******* deleting cart list addListToCart **********");
    state.cart.list = [];
    state.cart.list = items;
    console.log(
      "******* deleting cart list addListToCart ********** =>",
      state.cart.list
    );
  },
  removeFromCart(state, item, prop, field) {
    for (let i = 0; i < state.cart[prop].length; i++) {
      if (item[field] === state.cart[prop][i][field]) {
        state.cart[prop].splice(i, 1);
        break;
      }
    }
  },
  updateTransactions(state, data) {
    state.transactions = data;
  },
  updateSingleTransaction(state, data) {
    state.transaction = data;
  },

  updatePeopleCartList(state, data) {
    console.log("***** deleting cart list updatePeopleCartList ******");
    if (data) {
      console.log(
        "***** deleting cart list updatePeopleCartList ****** =>",
        data
      );
      state.cart.list = state.cart.list.filter(
        (item) => data.findIndex((el) => el.id === item.id) === -1
      );
    }
  },
};

/*============================ END OF SECTION ============================*/
